import { getMetaValue } from '@rad/utility/meta';
import { paymentUrls } from '../common/routes/urls/general';
export const getStaticNavigation = (settings) => {
    const nav = getMetaValue('76U-NAVIGATION');
    return nav.filter((x) => x.target === (paymentUrls === null || paymentUrls === void 0 ? void 0 : paymentUrls.pricing.getURL())
        ? settings.pricing
        : true);
};
